module.exports = __webpack_public_path__ + "public/img/jmzws.0e7f9d73.jpg";